// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--AlQ-H";
export var footerLinks = "footer-module--footer-links--SnM4+";
export var footerText = "footer-module--footer-text--iYGWa";